module.exports = __webpack_public_path__ + "img/lg_ring_y_0_1_1.6493fea9.png";